<ng-container *ngIf="form !== null">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>schedule</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">{{ esEdicion ? 'Editar turno' : 'Nuevo turno' }}</h2>
        <p class="cf-dlg-subtitle">Define el horario y los días de trabajo</p>
      </div>
    </div>

    <!-- BODY -->
    <div class="cf-dlg-body">
      <form [formGroup]="form">

        <!-- Empleado -->
        <employee-multi-select *ngIf="!esEdicion"
          [empleados]="empleados" [selectedIds]="form.value.employees_Ids"
          (selectedIdsChange)="form.controls['employees_Ids'].setValue($event)">
        </employee-multi-select>
        <mat-error *ngIf="!esEdicion && form.controls['employees_Ids']?.hasError('required')" style="font-size:12px; margin-bottom:8px">
          Debe seleccionar al menos un empleado
        </mat-error>
        <mat-form-field *ngIf="esEdicion" class="w-100" appearance="outline">
          <mat-label>Empleado</mat-label>
          <input matInput [value]="getNombreEmpleado(turno)" disabled>
        </mat-form-field>

        <!-- Nombre + Tipo -->
        <div class="cf-dlg-row">
          <app-input class="w-100" inputType="text" placeholder="Nombre del turno" [isRequired]="true"
            formControlName="nombre"></app-input>
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Tipo de turno</mat-label>
            <mat-select formControlName="tipo">
              <mat-option *ngFor="let t of listaTiposTurnos; trackBy: trackByIndex" [value]="t.valor">{{ t.etiqueta }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Fechas si tipo > 1 -->
        <div class="cf-dlg-row" *ngIf="form.value.tipo > 1">
          <mat-form-field appearance="outline">
            <mat-label>Fecha de inicio</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="inicio">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fecha de fin</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="fin">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Días + Intervalos -->
        <div class="cf-dlg-row">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Días de la semana</mat-label>
            <mat-select formControlName="diasALaSemana" multiple>
              <mat-option *ngFor="let dia of listaDiasSemana; trackBy: trackByIndex" [value]="dia.valor">{{ dia.etiqueta }}</mat-option>
            </mat-select>
            <mat-hint>Días en los que el empleado trabaja</mat-hint>
          </mat-form-field>
          <app-select class="w-100" [formControl]="form.get('horas')"
            [config]="{ label: 'Intervalos de horas', options: horasOptions }"></app-select>
        </div>

        <app-input *ngIf="form.value.horas === 'especificar'" class="w-100" inputType="text"
          placeholder="Intervalo personalizado (ej: 08:00-12:00, 13:00-17:00)" formControlName="horasPersonalizado"></app-input>

        <!-- Descripción -->
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Descripción (opcional)</mat-label>
          <textarea matInput rows="3" formControlName="descripcion"></textarea>
        </mat-form-field>

        <!-- Días de descanso -->
        <ng-container *ngIf="mostrarTablaFechasDescanso()">
          <span class="cf-dlg-section__label">Días de descanso</span>
          <div class="cf-dlg-row" style="align-items:flex-start">
            <div>
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Fecha de descanso</mat-label>
                <input matInput [matDatepicker]="picker3" formControlName="fechaDescanso">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
              </mat-form-field>
              <button mat-stroked-button (click)="agregarFecha()" style="margin-top:4px">
                <mat-icon>add</mat-icon> Agregar fecha
              </button>
            </div>
            <table class="table table-sm table-bordered" *ngIf="fechas?.length > 0" style="font-size:13px">
              <thead><tr><th>Fecha</th><th></th></tr></thead>
              <tbody>
                <tr *ngFor="let f of fechas; trackBy: trackByIndex">
                  <td>{{ f.cadena }}</td>
                  <td>
                    <button mat-icon-button (click)="eliminarFecha(f)" color="warn">
                      <mat-icon style="font-size:16px">delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

      </form>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
